import LBox from "@components/LBox";
import { webviewHtml } from "@components/PrebidPOC/webviewHtml";
import { useFeatureFlag } from "@utils/featureFlags";
import WebView from "react-native-webview";

export const PrebidPOC = () => {
  const { value: isPrebidPOCEnabled } = useFeatureFlag("PrebidPOC");

  if (!isPrebidPOCEnabled) {
    return null;
  }

  return (
    <LBox mb="m2" paddingHorizontal="s4">
      <WebView
        style={{ height: 200, flex: 0 }}
        source={{ html: webviewHtml }}
      />
    </LBox>
  );
};
